import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../../../../../../../shared/services/common.service';
import { RiskRegisterService } from '../risk-register.service';

/** Export options: statuses + internal rows (contractor copy excludes them). */
@Component({
  selector: 'app-risk-export-dialog',
  templateUrl: './risk-export-dialog.component.html',
  styleUrls: ['./risk-export-dialog.component.scss'],
  standalone: false,
})
export class RiskExportDialogComponent {
  statuses = [
    { value: 'open', label: 'Open', on: true }, { value: 'pending', label: 'Pending', on: true },
    { value: 'closed', label: 'Closed', on: true }, { value: 'converted', label: 'Converted', on: true },
  ];
  internal: 'exclude' | 'include' = 'exclude';
  busy = false;

  readonly dialogRef = inject<MatDialogRef<RiskExportDialogComponent>>(MatDialogRef);
  readonly data = inject<{ projectId: string; projectName: string; isContractor: boolean }>(MAT_DIALOG_DATA);
  private readonly riskService = inject(RiskRegisterService);
  private readonly commonService = inject(CommonService);

  download(): void {
    const status = this.statuses.filter(s => s.on).map(s => s.value);
    if (!status.length || this.busy) return;
    this.busy = true;
    const safe = (this.data.projectName || 'project').replace(/[\\/]/g, '_');
    this.riskService.export(this.data.projectId, { status, internal: this.data.isContractor ? 'exclude' : this.internal }, `${safe} - Risk register.xlsx`)
      .then(() => this.dialogRef.close(true))
      .catch(err => this.commonService.notification(err?.message || 'Export failed', 'error'))
      .finally(() => (this.busy = false));
  }
}
